<app-social-shell active="communities">
      <div class="so-page-head">
        <div>
          <h1>Communities</h1>
          <p>Find people who play like you do, or start a place for your own group.</p>
        </div>
        <a class="btn btn-theme cd-create" routerLink="/communities/new">
          <i class="fa fa-plus"></i> Create community
        </a>
      </div>

      <nav class="so-tabs" role="tablist" aria-label="Communities">
        <button role="tab" [attr.aria-selected]="tab === 'discover'" (click)="setTab('discover')">Discover</button>
        <button role="tab" [attr.aria-selected]="tab === 'mine'" (click)="setTab('mine')">Yours</button>
        <button role="tab" [attr.aria-selected]="tab === 'invites'" (click)="setTab('invites')">
          Invites
          @if (inviteCount) {
            <span class="so-count">{{ inviteCount }}</span>
          }
        </button>
      </nav>

      @if (tab !== 'invites') {
        <div class="cd-tools">
          <div class="so-search cd-search">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input type="search" placeholder="Search communities" aria-label="Search communities"
              [(ngModel)]="query" (ngModelChange)="onQuery($event)" />
          </div>
          <div class="so-chips" role="group" aria-label="Filter">
            <button type="button" [class.is-on]="privacy === ''" (click)="setPrivacy('')">All</button>
            <button type="button" [class.is-on]="privacy === 'public'" (click)="setPrivacy('public')">Public</button>
            <button type="button" [class.is-on]="privacy === 'private'" (click)="setPrivacy('private')">Private</button>
          </div>
        </div>

        @if (loading) {
          <div class="cd-grid" aria-busy="true" aria-label="Loading communities">
            @for (s of skeletons; track s) {
              <div class="cd-card cd-card--skel"><span class="cd-skel"></span><span class="cd-skel cd-skel--short"></span></div>
            }
          </div>
        } @else if (loadError) {
          <div class="so-card so-empty">
            <span class="so-empty-icon"><i class="fa fa-wifi"></i></span>
            <h3>Couldn't load communities</h3>
            <p>Check your connection and try again.</p>
            <button type="button" class="btn btn-theme" (click)="load()">Try again</button>
          </div>
        } @else if (!communities.length) {
          <div class="so-card so-empty">
            @if (query || privacy) {
              <h3>No communities match</h3>
              <p>Try another name, or clear the filter.</p>
            } @else if (tab === 'mine') {
              <span class="so-empty-icon"><i class="fa fa-users"></i></span>
              <h3>You haven't joined any communities yet</h3>
              <p>Find one in Discover, or start your own.</p>
              <button type="button" class="btn btn-theme" (click)="setTab('discover')">Discover communities</button>
            } @else {
              <span class="so-empty-icon"><i class="fa fa-users"></i></span>
              <h3>No communities yet</h3>
              <p>Be the first to start one.</p>
              <a class="btn btn-theme" routerLink="/communities/new">Create community</a>
            }
          </div>
        } @else {
          <div class="cd-grid">
            @for (c of communities; track c.id) {
              <article class="cd-card" tabindex="0" role="link" [attr.aria-label]="c.name" (click)="open(c.slug)" (keyup.enter)="open(c.slug)">
                <div class="cd-card-top">
                  <div class="cd-avatar">
                    @if (c.image) {
                      <img [src]="imageUrl(c.image)" alt="" (error)="c.image = null" />
                    } @else {
                      {{ initials(c.name) }}
                    }
                  </div>
                  <div class="cd-card-title">
                    <h2>{{ c.name }}</h2>
                    <span class="cd-sub">
                      <i class="fa" [class.fa-globe]="c.privacy === 'public'" [class.fa-lock]="c.privacy === 'private'"></i>
                      {{ c.privacy === 'public' ? 'Public' : 'Private' }} · {{ c.member_count }} member{{ c.member_count === 1 ? '' : 's' }}
                    </span>
                  </div>
                </div>
                <p class="cd-desc">{{ c.description || 'No description yet.' }}</p>
                <div class="cd-card-foot">
                  @if (c.my_role) {
                    <span class="cd-state cd-state--in"><i class="fa fa-check"></i> {{ c.my_role === 'member' ? 'Joined' : (c.my_role === 'owner' ? 'Owner' : 'Moderator') }}</span>
                  } @else if (c.my_request_pending) {
                    <span class="cd-state"><i class="fa fa-clock-o"></i> Request sent</span>
                  } @else if (c.my_invite_id) {
                    <button type="button" class="btn btn-theme" [disabled]="busy.has(c.id)" (click)="quickJoin(c, $event)">Accept invite</button>
                  } @else if (c.privacy === 'public') {
                    <button type="button" class="btn btn-theme" [disabled]="busy.has(c.id)" (click)="quickJoin(c, $event)">{{ busy.has(c.id) ? 'Joining…' : 'Join' }}</button>
                  } @else {
                    <button type="button" class="btn btn-dark" (click)="quickJoin(c, $event)">Ask to join</button>
                  }
                </div>
              </article>
            }
          </div>
          @if (hasMore) {
            <button type="button" class="so-more cd-more" [disabled]="loadingMore" (click)="load(true)">{{ loadingMore ? 'Loading…' : 'Load more' }}</button>
          }
        }
      } @else {
        @if (invitesLoading) {
          <div class="so-card so-card-pad"><span class="so-skel" style="height: 14px"></span></div>
        } @else if (!invites.length) {
          <div class="so-card so-empty">
            <span class="so-empty-icon"><i class="fa fa-envelope-open-o"></i></span>
            <h3>No invites right now</h3>
            <p>When someone invites you to a community, it shows up here.</p>
          </div>
        } @else {
          <ul class="so-card so-list cd-invites">
            @for (inv of invites; track inv.id) {
              <li>
                <div class="cd-avatar">
                  @if (inv.community.image) {
                    <img [src]="imageUrl(inv.community.image)" alt="" />
                  } @else {
                    {{ initials(inv.community.name) }}
                  }
                </div>
                <div class="cd-invite-text">
                  <a [routerLink]="['/communities', inv.community.slug]">{{ inv.community.name }}</a>
                  <span>
                    {{ inv.inviter?.name || 'Someone' }} invited you · {{ inv.community.member_count }} member{{ inv.community.member_count === 1 ? '' : 's' }}
                    · expires {{ inv.expires_at | date: 'MMM d' }}
                  </span>
                </div>
                <div class="cd-invite-actions">
                  <button type="button" class="btn btn-dark" [disabled]="answering.has(inv.id)" (click)="answer(inv, false)">Decline</button>
                  <button type="button" class="btn btn-theme" [disabled]="answering.has(inv.id)" (click)="answer(inv, true)">Accept</button>
                </div>
              </li>
            }
          </ul>
        }
      }
</app-social-shell>
